/**
 * Dynamic Customer Profile Targeting Feature
 * @module
 */

/**
 * PluginManager registration method
 * @param {PluginManager} PluginManager
 */
module.exports = function(PluginManager:PluginManagerClass) {
  PluginManager.registerApiModule('dcp', require('./helpers/api'));

  PluginManager.registerDependency('sources/dcp', require('./sources/dcp'));

  PluginManager.registerVisitorProfileProvider(require('./providers/dcp'));

  PluginManager.registerAudienceMatcher('dynamic_customer_profile', require('./matchers/dcp'));
};
